import React, {Component, Fragment} from "react"
import {get} from "lodash"
import styled from "styled-components"
import {connect} from "@irati/store"
import apps, {RECOGNITION} from "@irati-web/app/src/routeConfig"

import authentication from "@irati/auth"
import History, {appOrContext} from "@irati/utils/history"

import {Poll} from "@irati/types"
import {RecognitionRoutes} from "../../enums/Routes"
import {INSPIRE_MODE} from "../Popup/CreatePoll/Popup"
import PollBase from "./OpenPoll/Poll"

import {CreateAPoll, HaveYourSay, SeeWhosVoting, GetInspired, EarnRewards} from "./Empty/Cards"

const StyledPoll = styled(PollBase)`
  margin: 10px 0;
`

interface Props {
  polls: Poll[]
}

class OpenPolls extends Component<Props> {
  handleCreate() {
    History.push(appOrContext({to: RecognitionRoutes.CREATE_POLL, app: apps[RECOGNITION]}, {}))
  }

  handleGetInspired() {
    History.push(appOrContext({to: `${RecognitionRoutes.CREATE_POLL}?mode=${INSPIRE_MODE}`, app: apps[RECOGNITION]}, {}))
  }

  createFirstEmptyPoll = () => {
    const canCreatePoll = authentication.apps("recognition.poll.create")
    return canCreatePoll ? <CreateAPoll onClick={this.handleCreate} /> : <HaveYourSay />
  }

  createSecondEmptyPoll = () => {
    const canCreatePoll = authentication.apps("recognition.poll.create")
    return canCreatePoll ? <GetInspired onClick={this.handleGetInspired} /> : <SeeWhosVoting />
  }

  createThirdEmptyPoll = () => {
    const canCreatePoll = authentication.apps("recognition.poll.create")
    const canReward = authentication.apps("recognition.rewards.create")

    if (canReward) {
      return <EarnRewards />
    }
    return canCreatePoll ? <SeeWhosVoting /> : null
  }

  render() {
    const {polls} = this.props

    return (
      <Fragment>
        {polls.map((poll) => (
          <div key={poll.uuid}>
            <StyledPoll poll={poll} />
          </div>
        ))}
        {polls.length <= 2 && this.createFirstEmptyPoll()}
        {polls.length <= 1 && this.createSecondEmptyPoll()}
        {polls.length === 0 && this.createThirdEmptyPoll()}
      </Fragment>
    )
  }
}

const mapStateToProps = ({mq}) => ({
  isPhone: get(mq, "lessThan.medium", false),
  tabletBreakpoint: mq.breakpoints.small
})

export default connect(mapStateToProps)(OpenPolls)
